module.exports = __webpack_public_path__ + "img/bg-withdraw.df589df3.svg";